"use strict";
import classNames from "classnames";
import React, { forwardRef } from "react";
import * as styles from "./Heading-css";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
const defaultHeadingElements = /* @__PURE__ */ new Map([
  ["1", "h1"],
  ["2", "h2"],
  ["3", "h3"],
  ["4", "h4"],
  ["5", "h5"]
]);
export const Heading = forwardRef(
  ({ element, level, strong, secondary, align, theme, className, id, children, truncate, ...rest }, ref) => {
    const defaultElement = defaultHeadingElements.get(level);
    const HeadingElement = element || defaultElement || "span";
    return /* @__PURE__ */ React.createElement(
      HeadingElement,
      {
        id,
        className: classNames(
          "kl-heading",
          className,
          `kl-heading--level-${level}`,
          {
            [darkTheme]: theme === "dark",
            [lightTheme]: theme === "light",
            "kl-heading--strong": strong,
            "kl-heading--secondary": secondary,
            [`kl-heading--align-${align}`]: align
          },
          styles.heading({ strong, align, secondary, level, truncate })
        ),
        ref,
        ...rest
      },
      children
    );
  }
);
